<div class="flex flex-row items-center justify-between mb-10">
    <p-tabs [value]="url" class="md:w-96" scrollable>
        <p-tablist>
            @for(tab of tabs; track tab.label){
                <p-tab [value]="tab.route" [routerLink]="tab.route">
                    {{ tab.label }}
                </p-tab>
            }
        </p-tablist>
    </p-tabs>
</div>


<router-outlet />